import Token from '@/utils/Token';

/**
 * Layout de login do tenant resolvido no servidor (T3.1/T3.2).
 *
 * O `window.tenant` é injetado em `main.blade.php`, do mesmo jeito que
 * `constantes` e `permissoes`. Os padrões abaixo reproduzem o login do GTS:
 * se a página vier sem a variável (build antigo, erro de render), a tela
 * aparece igual à de hoje em vez de quebrar.
 */
const PADRAO = {
    slug: 'gts',
    nome: 'GTSNET',
    logo_login: '/logo_gts.png',
    imagem_fundo: null,
    video_fundo: null,
    cor_fundo: '#0f172a',
    cor_destaque: '#f59e0b',
    titulo_login: 'Acesso ao sistema',
};

const bruto = (typeof window !== 'undefined' && window.tenant) || {};

// Chave ausente cai no padrão; chave presente com valor nulo é intencional
// (o GTS não tem imagem de fundo, e isso não é a mesma coisa que "não veio").
const valor = (chave) => (chave in bruto ? bruto[chave] : PADRAO[chave]);

/**
 * Atalho `?d=` lido UMA vez, no boot.
 *
 * Fica preso à sessão da aba de propósito: a SPA troca de rota pelo router e a
 * querystring da URL some na primeira navegação. Sem isto o atalho valeria só
 * para a primeira tela — quem abriu o sistema como MAM Tech espera continuar
 * nela até recarregar.
 *
 * Na falta do parâmetro vale a empresa escolhida no switcher. É o que segura a
 * troca sem ela virar preferência: o switcher recarrega em `/app/home`, e sem
 * este degrau o servidor devolveria o usuário à empresa padrão no mesmo
 * instante. Ambos passam pela checagem de permissão do `ResolveTenantAtivo`.
 */
export const atalho = (() => {
    if (typeof window === 'undefined') {
        return null;
    }

    const daUrl = new URLSearchParams(window.location.search).get('d');

    if (daUrl) {
        Token.fixarTenantAtalho(daUrl);

        return daUrl;
    }

    return Token.tenantAtalho();
})();

export default {
    slug: valor('slug'),
    nome: valor('nome'),
    logo: valor('logo_login'),
    imagemFundo: valor('imagem_fundo'),
    videoFundo: valor('video_fundo'),
    corFundo: valor('cor_fundo'),
    corDestaque: valor('cor_destaque'),
    tituloLogin: valor('titulo_login'),
};
